<template>
  <div>
    <template v-if="!newRow.recognitionCount">
      <template v-if="!newRow.status">
        <span class="null">-</span>
      </template>
      <template v-if="newRow.status && (newRow.status.split('_')[1] ==='正在转换' || newRow.status.split('_')[1] === '正在分类' )">
        <div style="line-height: 1;">排队分类中...</div>
      </template>
      <template v-if="newRow.status && (newRow.status.split('_')[1] ==='正在识别' || newRow.status.split('_')[1] ==='分类成功' ) ">
        <div style="line-height: 1;">排队识别中...</div>
      </template>
    </template>
    <div class="row">
      <!-- @click.stop="handleSuccess(newRow)"  -->
      <a
        href="javascript:void(0)"
        class="successResult"
        v-if="newRow.recognitionCount && newRow.recognitionCount.success > 0"
      >
        <span>成功 {{newRow.recognitionCount.success > 0 ? newRow.recognitionCount.success : ''}}</span>
        <!-- <span>查看结果</span> -->
      </a>
      <span
        class="review"
        v-if="newRow.recognitionCount && newRow.recognitionCount.review > 0"
      >
        <span>已核对 {{newRow.recognitionCount.review > 0 ? newRow.recognitionCount.review : ''}}</span>
      </span>
      <!-- @click.stop="handleError(newRow)"  -->
      <a
        href="javascript:void(0)"
        class="failResult"
        v-if="newRow.recognitionCount && newRow.recognitionCount.failed > 0"
      >
        <span>失败 {{newRow.recognitionCount.failed > 0 ? newRow.recognitionCount.failed : ''}}</span>
        <!-- <span>人工处理</span> -->
      </a>
      <span
        class="manualProcess"
        v-if="newRow.recognitionCount && newRow.recognitionCount.manualProcess > 0"
      >
        <span>已处理 {{newRow.recognitionCount.manualProcess > 0 ? newRow.recognitionCount.manualProcess : ''}}</span>
      </span>
    </div>
    <!-- <div class="row">
      <a href="javascript:void(0)" @click.stop="handleError(newRow)" class="failResult" v-if="newRow.recognitionCount && newRow.recognitionCount.failed > 0">
        <span>失败 {{newRow.recognitionCount.failed > 0 ? newRow.recognitionCount.failed : ''}}</span>
        <span>人工处理</span>
      </a>
      <span class="manualProcess" v-if="newRow.recognitionCount && newRow.recognitionCount.manualProcess > 0">
        <span>已处理 {{newRow.recognitionCount.manualProcess > 0 ? newRow.recognitionCount.manualProcess : ''}}</span>
      </span>
    </div> -->
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'tableSocketResult',
  props: {
    row: Object
  },
  data () {
    return {
      newRow: {}
    }
  },
  computed: {},
  components: {},
  watch: {
    row: {
      handler: function (val, oldVal) {
        this.newRow = _.cloneDeep(val)
      },
      deep: true
    }
  },
  mounted () {
    this.newRow = _.cloneDeep(this.row)
  },
  methods: {
    handleSuccess (item) {
      let obj = JSON.stringify({
        id: item.id,
        name: item.resName,
        flag: true,
        search: 'success',
        hasChildren: item.hasChildren,
        pId: item.id,
        type: this.$route.name.split('-')[0]
      })
      this.$router.push({
        path: 'successPageRecog',
        query: {
          id: item.id,
          name: item.resName,
          flag: true,
          search: 'success',
          hasChildren: item.hasChildren,
          pId: item.id,
          type: this.$route.name.split('-')[0],
          params: obj
        }
      })

      return false
    },
    handleError (item) {
      if (
        item.format === 'doc' ||
        item.format === 'docx' ||
        item.format === 'jpeg' ||
        item.format === 'jpg'
      ) {
        item.hasChildren = false
      } else {
        item.hasChildren = true
      }
      let obj = JSON.stringify({
        id: item.id,
        name: item.resName,
        flag: false,
        search: 'fail',
        hasChildren: item.hasChildren,
        pId: item.id,
        type: this.$route.name.split('-')[0]
      })

      this.$router.push({
        path: 'failpage',
        query: {
          id: item.id,
          name: item.resName,
          flag: false,
          search: 'fail',
          hasChildren: item.hasChildren,
          pId: item.id,
          type: this.$route.name.split('-')[0],
          params: obj
        }
      })

      return false
    }
  }
}
</script>
<style>
</style>